<script setup lang="ts">
import type { Coverage } from "@/interfaces/product.interface";

import CoverageItem from "./CoverageItem.vue";

defineProps<{
  title?: number | string;
  coverages: Coverage[];
}>();

defineEmits<{
  (e: "openModal", coverage: Coverage): void;
}>();
</script>

<template>
  <section class="mt-2 md:mt-8">
    <h3 class="title mb-2 text-[15px] md:text-lg 2xl:text-xl py-4">
      Beneficio {{ title }}
    </h3>
    <article
      :class="[coverages.length >= 3 ? 'h-64 overflow-y-auto ' : 'h-auto']"
      class="border-section p-4 md:py-5 2xl:py-6 md:px-9 2xl:px-12"
    >
      <ul class="flex flex-col space-y-4">
        <template v-for="(coverage, index) of coverages" :key="coverage.id">
          <CoverageItem
            :coverage="coverage"
            @open-modal="$emit('openModal', coverage)"
          />
          <hr v-if="index < coverages.length - 1" />
        </template>
      </ul>
    </article>
  </section>
</template>

<style scoped></style>
